// Auto-generated normalizer for table: Cat_OperadoresABAC
export function catOperadoresABACNormalize(row) {
  return {
    idOperador: row.idOperador ?? row.IdOperador ?? row['IdOperador'] ?? 0,
    nombre: row.nombre ?? row.Nombre ?? row['Nombre'] ?? '',
    simbolo: row.simbolo ?? row.Simbolo ?? row['Simbolo'] ?? '',
    descripcion: row.descripcion ?? row.Descripcion ?? row['Descripcion'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
    fechaCreacion: row.fechaCreacion ?? row.FechaCreacion ?? row['FechaCreacion'] ?? null,
  };
}
